// extracted by mini-css-extract-plugin
export default {"SinglePost":"styles_SinglePost__3qG+n"};